import ApiLibrary3d from "utils/ApiLibrary3d";

class AutoCompleter {
  constructor(scenes, isOOP, isCreatedByDefault) {
    this.scenes = scenes;
    this.isOOP = isOOP;
    this.isCreatedByDefault = isCreatedByDefault;
    if (!this.isCreatedByDefault) this.apiList = ApiLibrary3d.getNewAllFunctions();
    else this.apiList = ApiLibrary3d.getAllFunctions();
    this.filteredApiList = this.getFilteredApiList();
    this.objectList = this.getObjectList();
  }

  getFilteredApiList() {
    if (this.isOOP) {
      // [TODO] develop api completion list
      const filteredApiList = this.isCreatedByDefault
        ? this.apiList.filter(({meta}) => meta === "conditional" || meta === "loop" || meta === "boolean")
        : this.apiList.filter(({meta}) => meta === "conditional" || meta === "loop" || meta === "boolean" || meta === "function");
      const builtinList = [
        "THREE",
        "TWEEN",
        "THREEADDON",
        "MathUtils",
        "DateUtils",
        "REDBRICK",
        "GUI",
        "WORLD",
        "Math",
        "GLOBAL",
        "Signal",
        "PLAYER",
      ];
      builtinList.forEach(name => filteredApiList.push({caption: name, value: name, meta: "module", score: Infinity}));
      return filteredApiList;
    } else {
      const captionList = this.apiList.map(({caption}) => caption);
      const filteredApiList = this.apiList.filter((item, index) => captionList.indexOf(item.caption) === index);
      return filteredApiList;
    }
  }

  getObjectList() {
    const objectList = [];
    if (this.isOOP) {
      this.scenes["default"].traverse(object => {
        objectList.push(object);
      });
      this.scenes["GUI"].traverse(object => {
        objectList.push(object);
      });
    } else {
      this.scenes["default"].traverse(object => {
        if (object.userData.canScript) objectList.push(object);
      });
      this.scenes["GUI"].traverse(object => {
        if (object.userData.canScript) objectList.push(object);
      });
    }
    return objectList;
  }

  getApiCompleter() {
    let list = this.filteredApiList.map(({caption, value, meta, score, newLine, selection}) => {
      return {
        caption,
        value,
        meta,
        score,
        completer: {
          insertMatch: editor => {
            editor.removeWordLeft();
            editor.insert(value);
            this.setNewLine(editor, newLine);
            if (caption === "switch~case") this.setNewLines(editor);
            this.setParamSelection(editor, newLine || value, selection);
          },
        },
      };
    });
    return {
      getCompletions: (editor, session, pos, prefix, callback) => {
        callback(null, list);
      },
    };
  }

  getObjectCompleter() {
    let list = this.objectList.map(({title}) => {
      return {
        caption: title,
        value: title,
        meta: "object",
        completer: {
          insertMatch: editor => {
            editor.removeWordLeft();
            editor.insert(title);
          },
        },
      };
    });
    return {
      getCompletions: (editor, session, pos, prefix, callback) => {
        const {row, column} = pos;
        const length = prefix.length;
        const wordPrefix = session.getTextRange({start: {row, column: column - (length + 1)}, end: {row, column: column - length}});
        if (wordPrefix === "'" || wordPrefix === `"` || wordPrefix === "`") {
          callback(null, list);
        }
      },
    };
  }

  updateObjectCompleter() {
    this.objectList = this.getObjectList();
    return this.getObjectCompleter();
  }

  setNewLine(editor, newLine) {
    if (newLine === undefined) return;

    const newLineRange = editor.find(newLine, {
      backwards: true,
      caseSensitive: true,
    });
    if (newLineRange === undefined) return;

    editor.selection.moveCursorToPosition(newLineRange.end);
    editor.selection.clearSelection();
    editor.insert(editor.session.doc.getNewLineCharacter());
  }

  setNewLines(editor) {
    const newLines = [`case "":`, `break;`, `default:`, `break;`];
    editor.insert(newLines.join(""));

    for (let i = newLines.length - 1; i > 0; i--) {
      const newLineRange = editor.find(newLines[i], {
        backwards: true,
        caseSensitive: true,
      });
      editor.selection.moveCursorToPosition(newLineRange.start);
      editor.selection.clearSelection();
      editor.insert(editor.session.doc.getNewLineCharacter());
    }
  }

  setParamSelection(editor, value, selection) {
    if (selection === undefined) return;

    const valueRange = editor.find(value, {
      backwards: true,
      caseSensitive: true,
    });
    if (valueRange === undefined) return;

    editor.selection.moveCursorToPosition(valueRange.start);
    const selectionRange = editor.find(selection, {
      backwards: false,
      caseSensitive: true,
    });
    if (selectionRange === undefined) return;

    // editor.selection.setSelectionRange(selectionRange, false);
  }
}

export default AutoCompleter;
